


import React, { useState, useEffect } from 'react';
import { Modal,Offcanvas } from 'react-bootstrap';

const LicenseModal = ({
  showModal,
  handleClose,
  addLicense,
  editLicense,
  selectedLicenseId,
  selectedLicenseData,

}) => {
  const [licenseData, setLicenseData] = useState({
    s_admin: '',
    admin: '',
    supervisor: '',
    team_lead: '',
    analyst: '',
    c_agent: '',
    v_agent: '',
    t_agent: '',
    agent: '',
    email: '',
    voicemail: '',
    chat: '',
    interaction: '',
    voice: '',
    api: '',
    start_date: '',
    validity: '',
    max_create:'',
    max_login:'0',
    mobile_app:'',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedLicenseData) {
      setLicenseData({ ...selectedLicenseData });
    }else {
      // If no data is provided (for Create), reset form fields
      setLicenseData({
        s_admin: '',
        admin: '',
        supervisor: '',
        team_lead: '',
        analyst: '',
        c_agent: '',
        v_agent: '',
        t_agent: '',
        agent: '',
        email: '',
        voicemail: '',
        chat: '',
        interaction: '',
        voice: '',
        api: '',
        start_date: '',
        validity: '',
        remarks: '', // Reset remarks too
        max_create:'',
        max_login:'0',
        mobile_app:'',
      });
    }
  }, [selectedLicenseId,selectedLicenseData]);

  const calculateMaxLogin = (data) => {
    const fields = ['s_admin', 'admin', 'supervisor', 'team_lead', 'analyst', 'c_agent', 'v_agent', 't_agent', 'agent'];
    return fields.reduce((sum, field) => sum + (Number(data[field]) || 0), 0);
  };
  
  useEffect(() => {
    const newMaxLogin = calculateMaxLogin(licenseData);
    const newMaxCreate = newMaxLogin * 3;
  
    setLicenseData(prevData => ({
      ...prevData,
      max_login: newMaxLogin,
      max_create: newMaxCreate// Prevent exceeding maxCreate
    }));
  }, [licenseData.s_admin, licenseData.admin, licenseData.supervisor, licenseData.team_lead, licenseData.analyst,
      licenseData.c_agent, licenseData.v_agent, licenseData.t_agent, licenseData.agent]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLicenseData((prevData) => {
      let updatedData = { ...prevData, [name]: value };
  
      if (name === 'max_create') {
        const maxAllowed = prevData.max_login * 3;
        updatedData.max_create = Math.min(Number(value) ||0,  maxAllowed); // Restrict input
      }
  
      return updatedData;
    });
  
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };
  
  useEffect(() => {
    if (!showModal) {
        setErrors({});
    }
}, [showModal]);
const validateForm = () => {
  const newErrors = {};
  if (!licenseData.start_date) newErrors.start_date = 'StartDate is required';
  if (!licenseData.validity) newErrors.validity = 'Validity is required';


  
  return newErrors;
};
const [loading, setLoading] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
    let apierrors;

    if (selectedLicenseData) {
      apierrors = await editLicense(selectedLicenseData.id, licenseData);
    } else {
      apierrors = await addLicense(licenseData);
    }
    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors); // Display validation errors
    } else {
      setErrors({}); // Clear errors on success
      handleClose(); // Close modal on success
    }
  };
 

  return (
    <>
     {showModal && (
                <div 
                    className="project-modal-backdrop"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Darker backdrop
                        zIndex: 1059, // Just below ProjectModal
                        backdropFilter: 'blur(2px)', // Optional: adds blur effect
                    }}
                    onClick={handleClose} // Close modal when backdrop is clicked
                />
            )}
    <Offcanvas show={showModal} onHide={handleClose} placement='end' style={{width:'700px'}}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{selectedLicenseData ? 'Edit License' : 'Add License'}</Offcanvas.Title>
      </Offcanvas.Header>
      <hr style={{ margin: 0 }} /><br/>

      <Offcanvas.Body>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>S_Admin</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="s_admin"
                  value={licenseData.s_admin}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Admin</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="admin"
                  value={licenseData.admin}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Supervisor</label>
                <input
                  type="number" 
                  style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                  name="supervisor"
                  value={licenseData.supervisor}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Team Lead</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="team_lead"
                  value={licenseData.team_lead}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Analyst</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="analyst"
                  value={licenseData.analyst}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>C_Agent</label>
                <input 
                                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}

                  type="number"
                  name="c_agent"
                  value={licenseData.c_agent}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>V_Agent</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="v_agent"
                  value={licenseData.v_agent}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>T_Agent</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="t_agent"
                  value={licenseData.t_agent}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Agent</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="agent"
                  value={licenseData.agent}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Email</label>
                <input
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="email"
                  value={licenseData.email}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Voicemail</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="voicemail"
                  value={licenseData.voicemail}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Chat</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="chat"
                  value={licenseData.chat}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Interaction</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="interaction"
                  value={licenseData.interaction}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Voice</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="voice"
                  value={licenseData.voice}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>API</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="api"
                  value={licenseData.api}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Mobile App</label>
                <input                     
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}

                  type="number"
                  name="mobile_app"
                  value={licenseData.mobile_app}
                  onChange={handleChange}
                  className='form-control'
                />

              </div>
            </div>
           
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Max Login</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="max_login"
                  value={licenseData.max_login}
                   readOnly
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Max Create</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="number"
                  name="max_create"
                  value={licenseData.max_create}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
         

          <div className="row">
          <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Start Date</label>
                <input                     style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}

                  type="date"
                  name="start_date"
                  value={licenseData.start_date}
                  onChange={handleChange}
                  className={`form-control ${errors?.start_date ? 'is-invalid' : ''}`}
                />
                                {errors.start_date && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.start_date}</div>}

              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Validity</label>
                <input 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    type="date"
                  name="validity"
                  value={licenseData.validity}
                  onChange={handleChange}
                  className={`form-control ${errors?.validity ? 'is-invalid' : ''}`}
                />
                                {errors.validity && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.validity}</div>}

              </div>
            </div>
            </div>
            <div className='row'>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label style={{fontSize:'13px'}}>Remarks</label>
                <textarea 
                    style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px',height: '39px',border: '0.5px solid rgb(232, 233, 237)' }}
                    name="remarks"
                  value={licenseData.remarks}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
      <div className="p-3 d-flex justify-content-end border-top">
      <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
          Close
        </button>
        <button type="button" className="btn btn-primary" onClick={handleSave}>
          Save
        </button>
      </div>
    </Offcanvas>
    </>
  );
};

export default LicenseModal;



















